<template>
  <div>
    <div class="intro">
      <h2>OUR SALE IS</h2>
      <h2>STARTING SOON</h2>
    </div>

    <p>{{ bodyCopy }}</p>

    <div class="countdown-block">
      <h2 v-if="mq?.mdPlus">SALE STARTS IN</h2>
      <Countdown :end="endDate" theme="editorial" />
    </div>

    <div class="button-group">
      <Button tag="a" theme="primary-light" width="full" :href="accountUrl">
        Go to your account
      </Button>
    </div>

    <p class="account-disclaimer">
      By creating an account, you agree to receive promotional emails and
      exclusive offers from Rat & Boa.
    </p>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import Countdown from "@/components/landing/Countdown.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "LandingSuccess",
  components: {
    Countdown,
    Button,
  },
  inject: ["mq"],
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState("auth", ["multipassAccount"]),
    bodyCopy() {
      if (this.mq?.mdPlus) {
        return "Log in to your Members Only account for early sale access, exclusive benefits and much more.";
      }

      return "Keep an eye on your inbox, we’ll email you all the details for your exclusive early sale access.";
    },
    accountUrl() {
      return this.multipassAccount?.url || "/account";
    },
  },
  mounted() {
    if (!this.multipassAccount?.url) {
      this.fetchMultipassAccount("/account");
    }
  },
  methods: {
    ...mapActions({ fetchMultipassAccount: "multipassAccount" }),
  },
};
</script>

<style lang="scss" scoped>
h2 {
  @include editorial-headline(24px);
  text-transform: uppercase;
  margin-bottom: 0;
}

.intro {
  margin-bottom: 16px;
}

p {
  @include editorial-body(14px);
  margin: 0 auto 28px;
}

.countdown-block {
  margin-bottom: 28px;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.account-disclaimer {
  @include utility-body(13px);
  margin: 28px auto 0;
}
</style>
